import type { IExercise } from '../exercises';

export const PERSONAL_EPISODE_03_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-personal-03-01",
    "name": "单手绳索臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["单臂绳索下压", "侧重三头外侧头"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/c3ced1d3cf33df306e076764.mp4",
    "videoUrl": "/media/collections-20261008/videos/ac11b1e60971b6f0678389af.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "beginner",
    "source": "私教跟练 · 第3期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-03-02",
    "name": "仰卧杠铃臂屈伸",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "triceps",
    "tips": ["大臂保持垂直", "曲杆杠铃更护肘"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 45,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/c201d239f456a0ca13627eab.mp4",
    "videoUrl": "/media/collections-20261008/videos/9af6f4f33e85bc19d44df41f.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "intermediate",
    "source": "私教跟练 · 第3期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-03-03",
    "name": "坐姿绳索二头弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌", "肱肌"],
    "demoUrl": "/media/collections-20261008/demos/reviewed-3701d3f862dc80d69590eaae.mp4",
    "videoUrl": "/media/collections-20261008/videos/864d96d44a560c26d4546723.mp4",
    "source": "私教跟练 · 第3期",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-03-04",
    "name": "仰卧哑铃肩伸位弯举",
    "bodyPart": "arms",
    "equipment": "dumbbell",
    "subCategory": "biceps",
    "tips": ["仰卧肩伸位长头受力更多", "控制离心阶段", "1热身+3正式组"],
    "sets": 3,
    "reps": "10",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "source": "私教跟练 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/e9a12864a660ed8bb80dede2.mp4",
    "videoUrl": "/media/collections-20261008/videos/fe16a2b2b07ed38af7ec6327.mp4",
    "targetMuscles": ["肱二头肌"],
    "difficulty": "intermediate",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-03-05",
    "name": "单手绳索肩屈位臂屈伸",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "triceps",
    "tips": ["肩屈位长头受力更多", "大臂保持稳定", "1热身+3正式组"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/2e33d1467ddd32adb23f7615.mp4",
    "videoUrl": "/media/collections-20261008/videos/8300e0d58090a57564d2f030.mp4",
    "targetMuscles": ["肱三头肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
  {
    "id": "course-20261008-personal-03-06",
    "name": "坐姿绳索内旋位弯举",
    "bodyPart": "arms",
    "equipment": "cable",
    "subCategory": "biceps",
    "tips": ["内旋位侧重肱肌", "控制动作节奏", "1热身+3正式组"],
    "sets": 3,
    "reps": "12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "私教跟练 · 第3期",
    "demoUrl": "/media/collections-20261008/demos/95e23d4cdb847b8844bdf575.mp4",
    "videoUrl": "/media/collections-20261008/videos/05b0ab4639967e231687cd03.mp4",
    "targetMuscles": ["肱肌", "肱二头肌"],
    "difficulty": "beginner",
    "demoStatus": "ready",
    "isStretch": false,
    "isWarmup": false,
  },
];
